export default "__VITE_ASSET__92f46d6e__"